module.exports = __webpack_public_path__ + "media/hallBgm.1be68e52.mp3";